import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { BaniDashboardComponent } from './components/bani-dashboard/bani-dashboard.component';
import { SearchComponent } from './components/search/search.component';
import { IntroductionComponent } from './components/introduction/introduction.component';
import { SignificantTermsComponent } from './components/significant-terms/significant-terms.component';
import { GuruGranthSahibComponent } from './components/guru-granth-sahib/guru-granth-sahib.component';
// import { DictionaryComponent } from './components/dictionary/dictionary.component';
import { MethodologyComponent } from './components/methodology/methodology.component';
import { NavigationComponent } from './components/navigation/navigation.component';
import { NewsComponent } from './components/news/news.component';
import { ArticlesComponent } from './components/articles/articles.component';
import { PressReleasesComponent } from './components/press-releases/press-releases.component';
import { CitationGuideComponent } from './components/citation-guide/citation-guide.component';
import { PrivacyPolicyComponent } from './components/privacy-policy/privacy-policy.component';
import { CopyrightComponent } from './components/copyright/copyright.component';
import { TermsOfUseComponent } from './components/terms-of-use/terms-of-use.component';
import { ContactUsComponent } from './components/contact-us/contact-us.component';
import { NewReleaseComponent } from './components/new-release/new-release.component';

import {
  OverviewComponent,
  SignificantTermsDetailComponent,
  ApproachComponent,
  GlossaryComponent,
  ContentCitationComponent,
  CorrectionComponent,
  BibliographyComponent,
  TranscriptionGuidelinesComponent,
  BaniSubDetailsComponent,
  TeamComponent,
  SiteMapComponent,
  ProjectComponent,
} from './components/components';
import { PageNotFoundComponent } from './components/page-not-found/page-not-found.component';
import { ArticleDetailComponent } from './components/article-details/article-details.component';

const routes: Routes = [
  {
    path: '',
    component: DashboardComponent,
  },
  {
    path: 'home',
    component: DashboardComponent,
  },
  {
    path: 'compositions/bani/:baniCode',
    component: BaniDashboardComponent,
  },
  {
    path: 'bani/:baniCode',
    component: BaniDashboardComponent,
  },
  {
    path: 'info/:language/new-release',
    component: NewReleaseComponent,
  },
  {
    path: 'info/:language/privacy-policy',
    component: PrivacyPolicyComponent,
  },
  {
    path: 'info/:language/copyright',
    component: CopyrightComponent,
  },
  {
    path: 'info/:language/terms-of-use',
    component: TermsOfUseComponent,
  },
  {
    path: 'info/:language/contact-us',
    component: ContactUsComponent,
  },
  {
    path: 'bani/details/:baniCode/:sectionSequence/:subSectionSequence',
    component: BaniSubDetailsComponent,
  },
  {
    path: 'compositions/bani/details/:baniCode/:sectionSequence/:subSectionSequence',
    component: BaniSubDetailsComponent,
  },
  {
    path: 'bani/introduction/:baniId/:introductionParam',
    component: IntroductionComponent,
  },
  {
    path: 'compositions/bani/introduction/:baniId/:introductionParam',
    component: IntroductionComponent,
  },
  {
    path: 'search',
    component: SearchComponent,
  },
  {
    path: 'compositions',
    component: SearchComponent,
  },
  {
    path: 'site-map',
    component: SiteMapComponent,
  },
  {
    path: 'glossary',
    component: SignificantTermsComponent,
  },
  {
    path: 'significant-terms',
    component: SignificantTermsComponent,
  },
  {
    path: 'significant-term-detail/:significantTermName',
    component: SignificantTermsDetailComponent,
  },
  {
    path: 'tggsp/english/SignificantTermsDetail/:significantTermName',
    component: SignificantTermsDetailComponent,
  },
  {
    path: 'tggsp/panjabi/SignificantTermsDetail/:significantTermName',
    component: SignificantTermsDetailComponent,
  },
  {
    path: 'info/:language/guru-granth-sahib',
    component: GuruGranthSahibComponent,
  },
  // {
  //   path: 'info/:language/dictionary',
  //   component: DictionaryComponent,
  // },
  {
    path: 'info/:language/news',
    component: NewsComponent,
  },
  {
    path: 'info/:language/articles',
    component: ArticlesComponent,
  },
  {
    path: 'info/:language/articlesDetail/:articleId',
    // path: 'info/:language/articlesDetail/',
    component: ArticleDetailComponent,
  },
  {
    path: 'info/:language/press-releases',
    component: PressReleasesComponent,
  },
  {
    path: 'info/:language/citation-guide',
    component: CitationGuideComponent,
  },
  {
    path: 'info/:language/methodology',
    component: MethodologyComponent,
  },
  {
    path: 'info/:language/navigation',
    component: NavigationComponent,
  },
  {
    path: 'info/:language/overview',
    component: OverviewComponent,
  },
  {
    path: 'info/:language/team',
    component: TeamComponent,
  },
  {
    path: 'info/:language/approach',
    component: ApproachComponent,
  },
  {
    path: 'info/:language/glossary1',
    component: GlossaryComponent,
  },
  {
    path: 'info/:language/content-citation',
    component: ContentCitationComponent,
  },
  {
    path: 'info/:language/corrections',
    component: CorrectionComponent,
  },
  {
    path: 'info/:language/bibliography',
    component: BibliographyComponent,
  },
  {
    path: 'info/:language/project',
    component: ProjectComponent,
  },
  {
    path: 'info/:language/transcription-guidelines',
    component: TranscriptionGuidelinesComponent,
  },
  {
    path: '**',
    component: PageNotFoundComponent,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    initialNavigation: 'enabledBlocking'
})],
  exports: [RouterModule],
})
export class AppRoutingModule {}
